import React, { useEffect, useState } from "react";
import { Dropdown, Flex } from "@fluentui/react-northstar";
import {
    AVATAR_DEFAULT,
    AVATAR_DEPARTMENT_DEFAULT,
} from "../../../../constants";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

const SearchBarEmployeeList = ({
    users = [],
    isLoading = false,
    onChangeUser = () => null,
    activeTab,
}) => {
    const [params, setSearchParams] = useSearchParams();
    const [searchQuery, setSearchQuery] = useState("");
    const [defaultValue, setDefaultValue] = useState(null);
    const [value, setValue] = useState(null);
    const [usersFormat, setUsersFormat] = useState([]);
    const paramID = params.get("id");
    console.log({ users });

    const userName = useMemo(() => {
        return users?.find((user) => user?.id === paramID)?.name;
    }, [users, paramID]);

    // useEffect(() => {
    //     const USERS = users?.map((user) => {
    //         return {
    //             id: user?.id,
    //             key: user?.id,
    //             header: user?.name,
    //             image: user?.avatar
    //                 ? user.avatar
    //                 : user?.is_department
    //                 ? AVATAR_DEPARTMENT_DEFAULT
    //                 : AVATAR_DEFAULT,
    //             is_department: user?.is_department,
    //         };
    //     });

    //     const defaultValue =
    //         USERS?.find((user) => user?.id === paramID) ?? null;
    //     setDefaultValue(defaultValue);
    //     setSearchQuery(defaultValue?.header ?? "");
    //     setUsersFormat(USERS);
    //     setValue(defaultValue);
    // }, [activeTab]);

    // const username = users?.find(
    //     (user) => user?.id === params?.get("id")
    // )?.name;

    // console.log({ hello: params.get("id"), username });

    const removeParams = (paramsToRemove) => {
        // Créer une copie des paramètres actuels
        const newSearchParams = new URLSearchParams(params);

        // Supprimer les paramètres spécifiés
        paramsToRemove.forEach((param) => {
            newSearchParams.delete(param);
        });

        // Mettre à jour les paramètres dans l'URL
        setSearchParams(newSearchParams);
    };

    // useEffect(() => {
    //     if (username) {
    //         return setSearchQuery(username);
    //     }
    //     setSearchQuery("");
    // }, [activeTab]);

    // if (isLoading) return "Chargement ...";

    const userObj = useMemo(() => {
        const foundUser = users?.find((user) => user?.id === paramID);
        return foundUser
            ? {
                  id: foundUser.id,
                  header: foundUser.name,
                  is_department: foundUser.is_department,
              }
            : null;
    }, [users, paramID]);

    useEffect(() => {
        // if (paramID) {
        setSearchQuery(userName || "");
        setValue(userObj);
        // }
    }, [paramID, userName, userObj]);

    // useEffect(() => {
    //     setSearchQuery("");
    // }, [activeTab]);

    const user_format = users?.map((user) => ({
        id: user?.id,
        key: user?.id,
        header: user?.name,
        image: user?.avatar
            ? user.avatar
            : user?.is_department
            ? AVATAR_DEPARTMENT_DEFAULT
            : AVATAR_DEFAULT,
        is_department: user?.is_department,
    }));

    return (
        <Flex fill>
            <DropdownStyle
                fluid
                search
                items={user_format}
                searchQuery={searchQuery}
                value={value}
                placeholder="Rechercher..."
                noResultsMessage="Nous n'avons pas trouvé de correspondance."
                a11ySelectedItemsMessage="Appuyez sur la touche Delete ou Backspace pour supprimer"
                checkable
                onSearchQueryChange={(e, data) => {
                    setSearchQuery(data.searchQuery);

                    // Cas où l'utilisateur efface tout → reset la sélection uniquement
                    if (data.searchQuery === "") {
                        setValue(null);
                        removeParams(["id", "type"]);
                        setDefaultValue(null);
                    }
                }}
                onChange={(e, i) => {
                    const id_user_selected = i?.value?.id;
                    const type = i?.value?.is_department
                        ? "department"
                        : "user";

                    setValue(i.value);
                    onChangeUser(id_user_selected, type);
                }}
                clearable={searchQuery !== ""}
            />
        </Flex>
    );
};

export default SearchBarEmployeeList;

const DropdownStyle = styled(Dropdown)`
    min-width: 100%;
`;
